<app-back-header 
  *ngIf="invoiceForm.get('is_draft')?.value == false"
  [headerText]="'Torna alle Fatture'" 
  (backAction)="onCancel()" 
  class="sticky-top">
</app-back-header>

<app-back-header  
  *ngIf="invoiceForm.get('is_draft')?.value == true"
  [headerText]="'Torna alle bozze'"
  (backAction)="onCancelDraft()" 
  class="sticky-top">
</app-back-header>

<h3>Dettaglio {{ displayDocumentType }}:</h3>

<p class="small text-muted" *ngIf="invoiceForm.get('healthcare_invoice')?.value === true">Questa {{ displayDocumentType }} riguarda una prestazione sanitaria.</p>
<p class="small text-muted" *ngIf="invoiceForm.get('paper_invoice')?.value === true">Questa {{ displayDocumentType }} è solo cartacea.</p>

<p 
  *ngIf="invoiceForm.get('is_draft')?.value == false" 
  class="small text-muted">
  I campi inseriti non sono modificabili.
</p>
<p 
  *ngIf="invoiceForm.get('is_draft')?.value == true" 
  class="small text-muted">
  Clicca su "Modifica" per apportare cambiamenti alla bozza.
</p>

<!-- <p>{{ displayDocumentType }}</p> -->
<!-- <p>Clicca su una scheda per espanderne il contenuto</p> -->

<div
  *ngIf="invoiceForm.get('is_draft')?.value == false"
  class="d-flex align-items-center gap-3 mb-3">
  <!-- paid status badge -->
  <mat-chip
    [color]="invoiceForm.get('is_paid')?.value ? 'primary' : 'warn'"
    matTooltip="Indica se la fattura è stata incassata."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    selected
    class="aligned-chip"
  >
    <mat-icon matChipAvatar>{{
      invoiceForm.get("is_paid")?.value ? "check_circle" : "cancel"
    }}</mat-icon>
    {{ invoiceForm.get("is_paid")?.value ? "INCASSATA" : "NON INCASSATA" }}
  </mat-chip>

  <!-- invoice send status badge -->
  <mat-chip
    [color]="invoiceForm.get('status')?.value ? 'primary' : 'warn'"
    (click)="handleInfoClick($event)"
    matTooltip="Informazioni aggiuntive sullo stato di invio."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    selected
  >
    {{ invoiceForm.get("status")?.value }}
  </mat-chip>
  <button 
    mat-icon-button 
    class="me-0" 
    (click)="handleInfoClick($event)"
    matTooltip="Informazioni aggiuntive sullo stato di invio."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    >
    <mat-icon>
      info
    </mat-icon>
  </button>
</div>

<div
  *ngIf="invoiceForm.get('is_draft')?.value == true"
  class="d-flex align-items-center gap-3 mb-3">
  <!-- draft badge -->
  <mat-chip selected>
    <mat-icon matChipAvatar>edit_document</mat-icon>
    Bozza
  </mat-chip>
</div>


<div class="col-md-12 d-flex flex-column mb-3">
  <mat-expansion-panel
    class="h-100 mt-md-0 mt-3 custom-card"
    #panelclient>
    <!-- <mat-card-content class="h-100"> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Cliente
        </mat-panel-title>
        <mat-panel-description>
          {{ company_name ?company_name : 'Nessuno' }}
          <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Cliente selezionato</h5> -->

      <!-- Add your content for the second card here -->
      <div class="d-flex flex-column h-100 justify-content-center">
        <div class="row">
          
          <!-- Show when no company is selected -->
          <div *ngIf="!company_id" class="text-center text-muted py-4">
            <mat-icon class="mb-2">face</mat-icon>
            <p>Nessun cliente selezionato</p>
            <small>Seleziona un cliente dalla barra di ricerca</small>
          </div>

          <div class="row">
            <!-- Show when company is selected -->
            <div *ngIf="company_name" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Nome</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_name }}
                </div>
              </div>
            </div>

            <div *ngIf="company_iva_number" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Partita IVA</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_iva_number }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          
          <!-- Show when no company is selected -->
          <div *ngIf="!company_id" class="text-center text-muted py-4">
            <mat-icon class="mb-2">face</mat-icon>
            <p>Nessun cliente selezionato</p>
            <small>Seleziona un cliente dalla barra di ricerca</small>
          </div>

          <div class="row">
            <!-- Show when company is selected -->
            <div *ngIf="company_address" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Indirizzo</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_address }}
                </div>
              </div>
            </div>

            <div *ngIf="company_addressee_code" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Codice SDI</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_addressee_code }}
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

  </mat-expansion-panel>    
</div>

<form [formGroup]="invoiceForm">
  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel
    >
    <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
      <mat-panel-title>
        Documento
      </mat-panel-title>
      <mat-panel-description>
        Num. {{ invoiceForm.get('progressive_number')?.value ? invoiceForm.get('progressive_number')?.value : 'n' }}/{{ invoiceForm.get('enumeration')?.value ? invoiceForm.get('enumeration')?.value : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Dati documento</h5> -->

      <div class="row">
        <!-- <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Nome fattura</mat-label>
          <input matInput formControlName="invoice_name"  readonly />
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numero progressivo</mat-label>
          <input
            matInput
            formControlName="progressive_number"
            [readonly]="shouldBeReadonly" 
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numerazione</mat-label>
          <input matInput formControlName="enumeration"  [readonly]="shouldBeReadonly" />
        </mat-form-field>

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25-mobile-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Valuta</mat-label>
          <input matInput formControlName="currency"  readonly />
        </mat-form-field>

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Valuta</mat-label>
            <mat-select
              formControlName="currency"
              name="currency"
              required
            >
              <mat-option
                *ngFor="let currency of currencyOptions"
                [value]="currency.code"
              >
                {{ currency.code }} - {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field
          appearance="outline" 
          class="w-sm-25-mobile-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Lingua</mat-label>
          <input 
            matInput 
            [value]="getLanguageDisplayName()" 
            readonly 
          />
        </mat-form-field>

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Lingua</mat-label>
            <mat-select
              formControlName="language"
              name="language"
              required
            >
              <mat-option
                *ngFor="let language of languageOptions"
                [value]="language.code"
              >
                {{ language.name }}
              </mat-option>
            </mat-select>
            <!-- <input
            matInput
            [(ngModel)]="newInvoice.language"
            name="language"
          /> -->
          </mat-form-field>

      </div>

      <div class="row">
        <!-- <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Valuta</mat-label>
          <mat-select formControlName="currency" [disabled]="true">
            <mat-option
              *ngFor="let type of currencyOptions"
              [value]="type.code"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Descrizione/Oggetto</mat-label>
          <textarea
            matInput
            formControlName="description"
            [readonly]="shouldBeReadonly"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note (opzionali)</mat-label>
          <textarea
            matInput
            formControlName="notes"
            [readonly]="shouldBeReadonly"
          ></textarea>
        </mat-form-field>

        <div class="ateco-code-section">
          <p class="mt-1 ms-1 small text-muted">Codice ATECO di riferimento della fattura:</p>
          
          <div class="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
            <div class="ateco-info">
              <p class="mb-0 small text-muted">{{ ateco_code_data?.name || 'Non disponibile' }}</p>
              <p class="mb-0">
                <strong *ngIf="ateco_code_data">
                  {{ ateco_code_data?.ateco_division || '' }}.{{ ateco_code_data?.ateco_class || '' }}.{{ ateco_code_data?.ateco_subcategory || '' }}
                </strong>
                <span *ngIf="!ateco_code_data" class="text-muted fst-italic">Nessun codice ATECO selezionato</span>
              </p>
            </div>
            
            <button 
              mat-raised-button
              color="primary"
              class="flex-shrink-0"
              (click)="changeInvoiceAtecoCode()"
              [disabled]="isLoading"
            >
              <mat-icon>edit</mat-icon>
              {{ ateco_code_data ? 'Modifica' : 'Seleziona' }}
            </button>
          </div>
        </div>
      
      </div>

      <!-- <div class="row">
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Descrizione interna</mat-label>
          <textarea
            matInput
            formControlName="description_internal"
            
            readonly
          ></textarea>
        </mat-form-field>
      </div> -->
    <!-- </mat-card-content> -->
  </mat-expansion-panel>

  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel2
    >
    <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Fatturazione
        </mat-panel-title>
        <mat-panel-description>
          {{ invoiceForm.get('document_type')?.value ? displayDocumentType : 'Fattura' }} - {{ formatFormDate('emission_date') }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Fatturazione elettronica</h5> -->

      <div class="row">

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25">
          <mat-label>Data di emissione</mat-label>
          <input 
            matInput 
            formControlName="emission_date" 
            readonly 
            [value]="formatFormDate('emission_date')"
          />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Data di emissione</mat-label>
          <input
            matInput
            [matDatepicker]="emissionDatePicker"
            formControlName="emission_date" 
            name="emission_date"
            required
          />
          <!-- (ngModelChange)="onEmissionDateChange($event)" -->
          <mat-datepicker-toggle
            matSuffix
            [for]="emissionDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #emissionDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25">
          <mat-label>Data di pagamento</mat-label>
          <input 
            matInput 
            formControlName="payment_date" 
            readonly 
            [value]="formatFormDate('payment_date')"
          />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Data di pagamento</mat-label>
          <input
            matInput
            [matDatepicker]="paymentDatePicker"
            formControlName="payment_date" 
            name="payment_date"
            required
          />
          <!-- (ngModelChange)="onEmissionDateChange($event)" -->
          <mat-datepicker-toggle
            matSuffix
            [for]="paymentDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #paymentDatePicker></mat-datepicker>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Metodo di pagamento</mat-label>
          <mat-select formControlName="payment_method" [disabled]="true">
            <mat-option
              *ngFor="let type of paymentMethodOptions"
              [value]="type.code"
            >
              {{ type.code }} - {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Esigibilità IVA</mat-label>
          <input matInput [value]="invoiceForm.get('iva_collectability')?.value" disabled readonly />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25" disabled>
            <mat-label>Esigibilità IVA</mat-label>
            <mat-select
              formControlName="iva_collectability"
              name="iva_collectability"
              [disabled]="true"
            >
              <!-- <mat-option
                *ngFor="let method of ivaCollectabilityOptions"
                [value]="method.code"
              >
                {{ method.name }}
              </mat-option> -->
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Codice destinatario</mat-label>
          <input 
            matInput 
            formControlName="addressee_code"
            [readonly]="shouldBeReadonly"
           />
        </mat-form-field>

      </div>

      <div class="row">
        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Nome destinatario</mat-label>
          <input matInput formControlName="addressee_name"  readonly />
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Tipo documento</mat-label>
          <input
            matInput
            [value]="displayDocumentType + (invoiceForm.get('p_a')?.value ? ' PA' : '')"
            readonly
            disabled
            placeholder="Seleziona tipo documento" />
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Metodo di pagamento</mat-label>
          <input matInput formControlName="payment_method"  readonly />
        </mat-form-field> -->

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Metodo di pagamento</mat-label>
          <input 
            matInput 
            [value]="displayPaymentMethodType" 
            readonly 
            placeholder="Seleziona tipo documento" />
        </mat-form-field>

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Metodo di pagamento</mat-label>
            <mat-select
              formControlName="payment_method"
              name="payment_method"
              required
            >
              <mat-option
                *ngFor="let method of paymentMethodOptions"
                [value]="method.code"
              >
                {{ method.code }} - {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>IBAN</mat-label>
          <input 
            matInput formControlName="iban"
            [readonly]="shouldBeReadonly"
            />
        </mat-form-field>

      </div>


      <div class="row">
        <!-- <div class="w-sm-25-mobile-25">
          <mat-label>Esigibilità IVA</mat-label>
          {{ invoiceForm.get('iva_collectability')?.value }}
        </div> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Marca da bollo</mat-label>
          <input matInput formControlName="revenue_stamp"  readonly />
        </mat-form-field> -->

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          >
          <mat-label>Marca da bollo a carico del cliente</mat-label>
          <input
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('revenue_stamp_for_company')?.value)" 
            readonly
            disabled
          />
        </mat-form-field>

        <!-- <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            [checked]="revenueStampOption === 'customer'"
            name="revenueStampCustomer"
            formControlName="revenue_stamp_for_company"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Marca da bollo a carico del cliente."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Bollo a carico del cliente
          </mat-slide-toggle>
        </div> -->

        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Pubblica Amministrazione</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('p_a')?.value)" 
            readonly 
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="revenueStampCustomer"
            formControlName="p_a"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura per Pubblica Amministrazione."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Pubblica Amministrazione
          </mat-slide-toggle>
        </div>

        <!-- For healthcare_invoice -->
        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Fattura sanitaria</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('healthcare_invoice')?.value)" 
            readonly 
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="healthcare_invoice"
            formControlName="healthcare_invoice"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura prestazione sanitaria. Queste fatture non vengono inoltrate allo SDI."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Fattura prestazione sanitaria
          </mat-slide-toggle>
        </div>

        <!-- For paper_invoice -->
        <mat-form-field 
          appearance="outline" 
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Fattura cartacea</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('paper_invoice')?.value)" 
            readonly 
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="paper_invoice"
            formControlName="paper_invoice"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura cartacea. Queste fatture non vengono inoltrate allo SDI."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Fattura cartacea
          </mat-slide-toggle>
        </div>

      </div>
    <!-- </mat-card-content> -->
  </mat-expansion-panel>

  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel3
    >
      <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ productServices.length }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
      <!-- <h6>Prodotti e servizi:</h6> -->
      
      <div class="hidden-mobile">

       <!-- Products and services table -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="table-container">
        <table mat-table [dataSource]="productServices" multiTemplateDataRows class="mat-elevation-z1">
          
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let product"> {{product.name}} </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Quantità </th>
            <td mat-cell *matCellDef="let product"> {{product.quantity}} </td>
          </ng-container>

          <!-- Units Column -->
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef> Unità </th>
            <td mat-cell *matCellDef="let product"> {{product.units}} </td>
          </ng-container>

          <!-- Gross Amount Column -->
          <ng-container matColumnDef="gross_amount">
            <th mat-header-cell *matHeaderCellDef> Importo Lordo </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.gross_amount) }} </td>
          </ng-container>

          <!-- Discount Column -->
          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef> Sconto (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.discount}}% </td>
          </ng-container>

          <!-- IVA Percentage Column -->
          <ng-container matColumnDef="iva_percentage">
            <th mat-header-cell *matHeaderCellDef> IVA (%) </th>
            <td mat-cell *matCellDef="let product"> {{ product.iva_percentage}}% </td>
          </ng-container>

          <!-- IVA Amount Column -->
          <ng-container matColumnDef="iva_amount">
            <th mat-header-cell *matHeaderCellDef> Importo IVA </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.iva_amount) }} </td>
          </ng-container>

          <!-- Final Amount Column -->
          <ng-container matColumnDef="final_amount">
            <th mat-header-cell *matHeaderCellDef> Totale </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.final_amount) }} </td>
          </ng-container>

          <ng-container matColumnDef="descriptionDetail">
            <td mat-cell *matCellDef="let product" [attr.colspan]="displayedColumns.length" class="description-cell">
              <div class="description-content" *ngIf="product.description">
                <strong>Descrizione:</strong> {{ product.description }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr mat-row 
      *matRowDef="let row; columns: ['descriptionDetail']" 
      class="description-row"
      [class.hidden-row]="!row.description">
  </tr>
  
        </table>

        <!-- Summary of product services -->
        <mat-divider class="mt-2"></mat-divider>
        <div class="product-summary me-2 mt-1 mb-3">
          <div class="summary-item ms-2">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ formatCardAmount(getTotalProductServices()) }}</span>
          </div>
          <div class="summary-item ms-2">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- mobile cards -->
    <div class="visible-mobile">
      <!-- here -->
       <h6 class="mt-2">Prodotti e servizi:</h6>

      <!-- Mobile loading state -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <!-- Mobile empty state -->
      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <!-- Mobile product cards -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="mobile-products-container">
        <mat-card *ngFor="let product of productServices" class="product-card mb-3">
          <mat-card-header class="pb-2">
            <mat-card-title class="product-name">{{ product.name }}</mat-card-title>
          </mat-card-header>
          
          <mat-card-content class="product-details">
            <div class="detail-row">
              <span class="label">Quantità:</span>
              <span class="value">{{ product.quantity }} {{ product.units }}</span>
            </div>
            
            <div class="detail-row">
              <span class="label">Importo lordo:</span>
              <span class="value">{{ formatCardAmount(product.gross_amount) }}</span>
            </div>
            
            <div class="detail-row" *ngIf="product.discount">
              <span class="label">Sconto:</span>
              <span class="value">{{ product.discount }}%</span>
            </div>
            
            <div class="detail-row">
              <span class="label">IVA:</span>
              <span class="value">{{ product.iva_percentage }}% ({{ formatCardAmount(product.iva_amount) }})</span>
            </div>
            
            <mat-divider class="my-2"></mat-divider>
            
            <div class="detail-row total">
              <span class="label">Totale:</span>
              <span class="value">{{ formatCardAmount(product.final_amount) }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mobile summary -->
        <div class="product-summary mt-3">
          <mat-divider></mat-divider>
          <div class="summary-item">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ formatCardAmount(getTotalProductServices()) }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>
    </div>

  </mat-expansion-panel>

  <mat-card class="mb-3 col-md-12 d-flex flex-column custom-card">
    <mat-card-content>
      <h4 class="m-2">Riepilogo:</h4>

      <p 
        class="ms-2 colored-primary-text" 
        *ngIf="invoiceForm.get('healthcare_invoice')?.value === true || invoiceForm.get('paper_invoice')?.value === true"
      >
      Questa {{ displayDocumentType }} è solo cartacea. Non verrà emessa come {{ displayDocumentType }} Elettronica.</p>

      <!-- <div class="summary-item">
        <span class="label">Numero articoli:</span>
         <span class="value">{{ productServices.length }}</span>
      </div> -->

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Competenze:</span>
        <span class="fw-medium">{{ formatCardAmount(invoiceForm.get('gross_amount')?.value) }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Marca da bollo:</span>
        <span class="value"> {{ formatCardAmount(invoiceForm.get('revenue_stamp')?.value) }}</span>
      </div>

      <div class="summary-item" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          Sconto:
        </span>
        <span class="value" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('discount_amount')?.value) }} 
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('revenge')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('revenge')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('revenge')?.value > 0">
          Rivalsa ({{invoiceForm.get('revenge_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('revenge')?.value > 0">
          + {{ formatCardAmount(invoiceForm.get('revenge')?.value) }} 
        </span>
      </div>

      <mat-divider class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          Cassa previdenziale ({{invoiceForm.get('pension_fund_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          + {{ formatCardAmount(invoiceForm.get('pension_fund')?.value) }}
        </span>
      </div>
      <span class="ms-2 small text-muted" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
         {{ getPensionFundDisplayName() }} 
      </span>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Imponibile:</span>
        <span class="fw-medium">{{ formatCardAmount(invoiceForm.get('taxable_amount')?.value) }}</span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="label">Iva ({{invoiceForm.get('iva_percentage')?.value}}%):</span>
        <span class="value">+ {{ formatCardAmount(invoiceForm.get('iva_amount')?.value) }}</span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"
          >Ritenuta d'acconto ({{invoiceForm.get('withholding_advance_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('withholding_advance_tax')?.value) }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          Ritenuta ({{invoiceForm.get('withholding_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('withholding_tax')?.value) }}
        </span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item total">
        <span class="label">Totale da incassare:</span>
        <span class="value">{{ formatCardAmount(invoiceForm.get('amount')?.value) }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</form>

  <div class="pb-3 ms-3 d-flex flex-column align-self-end">
    <div class="mb-3 d-flex align-self-end">

      <!-- Bottoni sempre disponibili -->
      <button
        mat-raised-button
        color="primary"
        class="me-3 hidden-mobile"
        (click)="downloadPdf()"
      >
        <mat-icon>print</mat-icon>
        Scarica PDF
      </button>
      <button
        mat-raised-button
        color="primary"
        class="me-3 hidden-mobile"
        (click)="downloadXml()"
      >
        <mat-icon>download</mat-icon>
        Download XML
      </button>
      <button
        mat-raised-button
        color="primary"
        class="me-3 hidden-mobile"
        (click)="sendInvoiceEmail()"
      >
        <mat-icon>outgoing_mail</mat-icon>
        Invia fattura per email
      </button>

      <!-- Modalità Visualizzazione -->
      <ng-container *ngIf="!isEditMode">
        <button
          *ngIf="invoiceForm.get('is_draft')?.value == true"
          mat-raised-button
          color="primary"
          class="me-3 hidden-mobile"
          (click)="enableEditMode(); isEditMode = true"
        >
          <mat-icon>edit</mat-icon>
          Modifica bozza
        </button>
        <button
          *ngIf="invoiceForm.get('is_draft')?.value == false"
          mat-raised-button
          color="primary"
          class="me-3 hidden-mobile"
          (click)="duplicateInvoice()"
          [disabled]="isLoading"
        >
          <mat-icon>copy_all</mat-icon>
          Duplica
        </button>

        <button
        *ngIf="invoiceForm.get('is_draft')?.value == true && !isEditMode"
        mat-raised-button
        color="primary"
        class="me-3 hidden-mobile"
        (click)="publishDraft()"
        [disabled]="isLoading"
        >
          <mat-icon>send</mat-icon>
          Pubblica
        </button>
      </ng-container>

      <!-- Modalità Modifica -->
      <ng-container *ngIf="isEditMode">
        <button
          mat-raised-button
          color="primary"
          class="me-3 hidden-mobile"
          (click)="saveDraft(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>save</mat-icon>
          Salva modifiche
        </button>
        <button
          mat-stroked-button
          color="warn"
          class="me-3 hidden-mobile"
          (click)="cancelEdit(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>cancel</mat-icon>
          Annulla
        </button>
      </ng-container>
    </div>

    <!-- Versione Mobile -->
    <div class="mb-3 d-flex align-self-center">

      <button
        mat-raised-button
        color="primary"
        class="me-3 visible-mobile"
        (click)="downloadPdf()"
      >
        <mat-icon>print</mat-icon>
        PDF
      </button>
      <button
        mat-raised-button
        color="primary"
        class="me-3 visible-mobile"
        (click)="downloadXml()"
      >
        <mat-icon>download</mat-icon>
        XML
      </button>

    </div>
    <!-- Mail send button for mobile -->
    <div 
      *ngIf="invoiceForm.get('is_draft')?.value == false" 
      class="mb-3 d-flex align-self-center">

      <button
        mat-raised-button
        color="primary"
        class="me-3 visible-mobile"
        (click)="sendInvoiceEmail()"
      >
        <mat-icon>outgoing_mail</mat-icon>
        Invia fattura per email
      </button>

    </div>

    <div class="mb-3 d-flex align-self-center">

      <!-- Modalità Visualizzazione -->
      <ng-container *ngIf="!isEditMode">
        <button 
          *ngIf="invoiceForm.get('is_draft')?.value == true"
          mat-raised-button
          color="primary"
          class="me-3 visible-mobile flex-shrink-0"
          (click)="enableEditMode(); isEditMode = true"
        >
          <mat-icon>edit</mat-icon>
          Modifica
        </button>
        <button
          *ngIf="invoiceForm.get('is_draft')?.value == false"
          mat-raised-button
          color="primary"
          class="me-3 visible-mobile"
          (click)="duplicateInvoice()"
          [disabled]="isLoading"
        >
          <mat-icon>copy_all</mat-icon>
          Duplica
        </button>
        <button
        *ngIf="invoiceForm.get('is_draft')?.value == true && !isEditMode"
        mat-raised-button
        color="primary"
        class="me-3 visible-mobile"
        (click)="publishDraft()"
        [disabled]="isLoading"
        >
          <mat-icon>send</mat-icon>
          Pubblica
        </button>

      </ng-container>

      <!-- Modalità Modifica -->
      <ng-container *ngIf="isEditMode">
        <button
          mat-raised-button
          color="primary"
          class="me-3 visible-mobile"
          (click)="saveDraft(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>save</mat-icon>
          Salva
        </button>
        <button
          mat-stroked-button
          color="warn"
          class="me-3 visible-mobile"
          (click)="cancelEdit(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>cancel</mat-icon>
          Annulla
        </button>
      </ng-container>
    </div>

  </div>

  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Salvataggio in corso...</p>
  </div>

<!-- <div class="pt-3 mb-3"></div> -->
